import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, MessageCircle } from "lucide-react";
import { CONTACT, NAV_LINKS } from "../mock";

const Footer = () => {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="relative bg-[#08080a] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12">
          <div>
            <span className="font-display font-extrabold text-2xl tracking-tight text-white">
              BS<span className="racing-text">IMPORT</span> AUTO
            </span>
            <p className="mt-4 text-white/50 leading-relaxed max-w-xs">
              Courtage & importation de véhicules sportifs. Trouvez, achetez et
              immatriculez votre bolide en toute sérénité.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-white/5 hover:bg-[#ff6a00]/20 flex items-center justify-center text-white/70 hover:text-white transition-colors">
                <MessageCircle size={18} />
              </a>
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-lg bg-white/5 hover:bg-[#ff6a00]/20 flex items-center justify-center text-white/70 hover:text-white transition-colors">
                <Instagram size={18} />
              </a>
              <a href={`mailto:${CONTACT.email}`} className="w-10 h-10 rounded-lg bg-white/5 hover:bg-[#ff6a00]/20 flex items-center justify-center text-white/70 hover:text-white transition-colors">
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-5">Navigation</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <button onClick={() => scrollTo(link.href)} className="text-white/50 hover:text-[#ff6a00] transition-colors">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-5">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-white/50 hover:text-white transition-colors">
                  <Phone size={16} className="text-[#ff6a00]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-white/50 hover:text-white transition-colors">
                  <Mail size={16} className="text-[#ff6a00]" /> {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} BS Import Auto. Tous droits réservés.
          </p>
          <div className="flex items-center gap-5 text-sm">
            <Link to="/mentions-legales" className="text-white/45 hover:text-[#ff6a00] transition-colors">
              Mentions légales
            </Link>
            <span className="text-white/15">•</span>
            <Link to="/politique-confidentialite" className="text-white/45 hover:text-[#ff6a00] transition-colors">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
